import { InsightArticle } from "@/components/insight/InsightArticle";
import { auditVsStrategy } from "@/data/insights/auditVsStrategy";
import { technicalPrioritization } from "@/data/insights/technicalPrioritization";
import { seoForAiSearch } from "@/data/insights/seoForAiSearch";
import { geoAeoAiSeo } from "@/data/insights/geoAeoAiSeo";
import { keywordsNotInternational } from "@/data/insights/keywordsNotInternational";
import { hispanicMarketSeo } from "@/data/insights/hispanicMarketSeo";
import { categoryVsProduct } from "@/data/insights/categoryVsProduct";
import { amazonSeoVsAds } from "@/data/insights/amazonSeoVsAds";
import { consultantVsAgency } from "@/data/insights/consultantVsAgency";

export const AuditVsStrategyArticle = () => <InsightArticle content={auditVsStrategy} />;
export const TechnicalPrioritizationArticle = () => <InsightArticle content={technicalPrioritization} />;
export const SeoForAiSearchArticle = () => <InsightArticle content={seoForAiSearch} />;
export const GeoAeoAiSeoArticle = () => <InsightArticle content={geoAeoAiSeo} />;
export const KeywordsNotInternationalArticle = () => <InsightArticle content={keywordsNotInternational} />;
export const HispanicMarketSeoArticle = () => <InsightArticle content={hispanicMarketSeo} />;
export const CategoryVsProductArticle = () => <InsightArticle content={categoryVsProduct} />;
export const AmazonSeoVsAdsArticle = () => <InsightArticle content={amazonSeoVsAds} />;
export const ConsultantVsAgencyArticle = () => <InsightArticle content={consultantVsAgency} />;
